import { spliceQueryParameter } from '../utils/url';
var StepinViewPlugin = {
  install: function install(app) {
    var _ref = arguments.length <= 1 ? undefined : arguments[1],
      router = _ref.router;
    router.beforeEach(function (to, from) {
      var query = to.query,
        meta = to.meta;
      if (query !== null && query !== void 0 && query._to_view) {
        if (!meta) {
          to.meta = {};
        }
        var route = to;
        route.meta._to_view = query._to_view;
        route.path && (route.path = spliceQueryParameter(route.path, '_to_view'));
        route.fullPath && (route.fullPath = spliceQueryParameter(route.fullPath, '_to_view'));
        route.href && (route.href = spliceQueryParameter(route.href, '_to_view'));
        delete query._to_view;
      }
    });
  }
};
export default StepinViewPlugin;